/* React */
import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';

/* Interfaces */
import { IUserData } from '../../interfaces/auth';

/* Hooks */
import { useAuth } from '../../hooks/auth';

/* Styles */
import {
  Container,
  Content,
  FormWrapper,
  LoginOptions,
  DescriptionTerms,
  ModalTerms,
} from './styles';

/* antd */
import { Form, message, Input, Row, Col } from 'antd';

/* Components */
import { Header } from '../../components/Header';
import Footer from '../../components/Footer';

/* Assets */
import Coruja from '../../assets/img/pet/corujaFeliz.png';

/* Icons */
import { FaGoogle, FaFacebookF, FaAppleAlt } from 'react-icons/fa';
import { ImSpinner2 } from 'react-icons/im';
import Terms from '../../components/Terms';

const Register: React.FC = () => {
  const [checked, setChecked] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const {
    signUp,
    SignInWithGoogle,
    SignInWithFacebook,
    SignInWithApple,
    loadingGoogle,
    setLoadingGoogle,
    loadingFacebook,
    setLoadingFacebook,
    loadingApple,
    setLoadingApple,
  } = useAuth();
  const [formRegister] = Form.useForm();

  const handleRegisterSubmit = useCallback(() => {
    formRegister.submit();
  }, [formRegister]);

  const handleRegister = useCallback(
    async (data: IUserData) => {
      try {
        if (data.confirmarSenha === data.senha) {
          await signUp({
            nome: data.nome,
            sobrenome: data.sobrenome,
            email: data.email,
            telefone: data.telefone,
            senha: data.senha,
            confirmarSenha: data.confirmarSenha,
          });
        } else {
          message.error('As senhas são diferentes!');
        }
      } catch (err: any) {
        if (err.response.data.erros.email)
          message.error(err.response.data.erros.email);
        if (err.response.data.erros.celular)
          message.error(err.response.data.erros.celular);
        if (err.response.data.erros.password)
          message.error(err.response.data.erros.password);
      }
    },
    [signUp]
  );

  return (
    <Container>
      <ModalTerms isVisible={openModal}>
        <section>
          <header>
            <h1>Termos de uso e políticas de privacidade</h1>
            <h1
              onClick={() => {
                setOpenModal(false);
              }}
            >
              X
            </h1>
          </header>
          <main>
            <Terms />
          </main>
          <footer>
            <button
              onClick={() => {
                setOpenModal(false);
              }}
            >
              Cancelar
            </button>
            <button
              onClick={() => {
                setChecked(true);
                setOpenModal(false);
              }}
            >
              Aceitar
            </button>
          </footer>
        </section>
      </ModalTerms>

      <Header />
      <Content>
        <main>
          <LoginOptions>
            <button
              onClick={() => {
                SignInWithGoogle('register');
                setLoadingGoogle(true);
              }}
            >
              {loadingGoogle ? (
                <h1 className="spinner">
                  <ImSpinner2 />
                </h1>
              ) : (
                <h1>
                  <FaGoogle />
                </h1>
              )}
            </button>
            <button
              onClick={() => {
                SignInWithFacebook('register');
                setLoadingFacebook(true);
              }}
            >
              {loadingFacebook ? (
                <h1 className="spinner">
                  <ImSpinner2 />
                </h1>
              ) : (
                <h1>
                  <FaFacebookF />
                </h1>
              )}
            </button>
            <button
              onClick={() => {
                SignInWithApple('register');
                setLoadingApple(true);
              }}
            >
              {loadingApple ? (
                <h1 className="spinner">
                  <ImSpinner2 />
                </h1>
              ) : (
                <h1>
                  <FaAppleAlt />
                </h1>
              )}
            </button>
          </LoginOptions>

          <FormWrapper>
            <Form
              style={{ padding: '15px 15px 0 15px' }}
              form={formRegister}
              layout="vertical"
              requiredMark={false}
              onFinish={handleRegister}
              onFinishFailed={() =>
                message.error('Ocorreu um erro, tente novamente!', 3)
              }
            >
              <Row style={{ justifyContent: 'space-between' }}>
                <Col span={11}>
                  <label>Nome</label>
                  <Form.Item
                    name="nome"
                    rules={[
                      {
                        required: true,
                        type: 'string',
                        message: 'Insira seu nome!',
                      },
                    ]}
                  >
                    <Input
                      bordered={false}
                      style={{
                        borderBottom: '1px solid black',
                        marginTop: '5px',
                        fontSize: '18px',
                        padding: '2px 5px 0 5px',
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={11}>
                  <label>sobrenome</label>
                  <Form.Item
                    name="sobrenome"
                    rules={[
                      {
                        required: true,
                        type: 'string',
                        message: 'Insira seu sobrenome!',
                      },
                    ]}
                  >
                    <Input
                      bordered={false}
                      style={{
                        borderBottom: '1px solid black',
                        marginTop: '5px',
                        fontSize: '18px',
                        padding: '2px 5px 0 5px',
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ justifyContent: 'space-between' }}>
                <Col span={11}>
                  <label>E-mail</label>
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        required: true,
                        type: 'email',
                        message: 'Insira seu e-mail!',
                      },
                    ]}
                  >
                    <Input
                      bordered={false}
                      style={{
                        borderBottom: '1px solid black',
                        marginTop: '5px',
                        fontSize: '18px',
                        padding: '2px 5px 0 5px',
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={11}>
                  <label>Telefone</label>
                  <Form.Item
                    name="telefone"
                    rules={[
                      {
                        required: true,
                        message: 'Insira seu telefone!',
                      },
                    ]}
                  >
                    <Input
                      bordered={false}
                      placeholder="XX9XXXXXXXX"
                      style={{
                        borderBottom: '1px solid black',
                        marginTop: '5px',
                        fontSize: '18px',
                        padding: '2px 5px 0 5px',
                      }}
                      type="tel"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ justifyContent: 'space-between' }}>
                <Col span={11}>
                  <label>Senha</label>
                  <Form.Item
                    name="senha"
                    rules={[
                      {
                        required: true,
                        type: 'string',
                        message: 'Insira sua senha!',
                      },
                    ]}
                  >
                    <Input.Password
                      bordered={false}
                      style={{
                        borderBottom: '1px solid black',
                        marginTop: '5px',
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={11}>
                  <label>Confirme sua senha</label>
                  <Form.Item
                    name="confirmarSenha"
                    rules={[
                      {
                        required: true,
                        type: 'string',
                        message: 'Insira sua senha novamente!',
                      },
                    ]}
                  >
                    <Input.Password
                      bordered={false}
                      style={{
                        borderBottom: '1px solid black',
                        marginTop: '5px',
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <DescriptionTerms>
              <input
                type="checkbox"
                checked={checked}
                onChange={() => setChecked(!checked)}
              />
              <p>
                Li e concordo com os
                <span
                  onClick={() => {
                    setOpenModal(true);
                  }}
                >
                  {' '}
                  Termos de Uso e as Políticas de Privacidade.
                </span>
              </p>
            </DescriptionTerms>
            <button disabled={!checked} onClick={handleRegisterSubmit}>
              cadastrar
            </button>
          </FormWrapper>
          <section>
            <p>Já possui uma conta?</p>
            <Link to="/">
              <span>faça login</span>
            </Link>
          </section>
        </main>
        <aside>
          <img src={Coruja} alt="Imagem de uma coruja" />
        </aside>
      </Content>
      <Footer />
    </Container>
  );
};

export default Register;
